import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import { useInterval } from "hooks/setInterval";

import { Wrapper, HeaderWrapper, ButtonPositioner } from '../pageComponents/index.styles'
import { LandingCarousel } from "customOrganism"
import { Footer } from "customMolecule"
import { Logo, SplashText } from "customAtom"
import { Button } from 'atom'
import { SplashButton } from 'customAtom';
import SEO from "../components/seo/SEO"
import Globals from "../components/globals/Globals"

const Landing = ({ data }) => {

  const [carouselPosition, setCarouselPosition] = useState('0')

  useEffect(() => {
    setTimeout(() => setCarouselPosition('1'), 5000)
    setTimeout(() => setCarouselPosition('2'), 9000)
    setTimeout(() => setCarouselPosition('3'), 13000)
    setTimeout(() => setCarouselPosition('1'), 17000)
    setTimeout(() => setCarouselPosition('2'), 21000)
    setTimeout(() => setCarouselPosition('3'), 25000)
    setTimeout(() => setCarouselPosition('1'), 29000)
  }, [])

  return (
    <>
      <SEO />
      <Globals>
        <Wrapper>
          <header>
            <HeaderWrapper>
              <Logo />
              <Button text={"Let's go"} href={'/home'} />
            </HeaderWrapper>
          </header>
          <div id='background-image' >
            <LandingCarousel imageData={data} carouselPosition={carouselPosition} />
          </div>
          <main>
            <SplashText carouselPosition={carouselPosition} />
            <ButtonPositioner>
              <SplashButton href={'/home'} />
            </ButtonPositioner>
          </main>
          <Footer extraPadding={false} />
        </Wrapper>
      </Globals >
    </>
  )
}


export const query = graphql`
  {
    
    imgLanding1: file(relativePath: { eq: "landing1.jpeg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    imgLanding2: file(relativePath: { eq: "landing2.jpeg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    imgLanding3: file(relativePath: { eq: "landing3.jpeg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }

  }

`


export default Landing
